import {
	REVISION,
	AmbientLight,
	AxesHelper,
	BackSide,
	Box3,
	BoxGeometry,
	BoxHelper,
	Color,
	CubeCamera,
	CubeGeometry,
	CylinderGeometry,
	DirectionalLightHelper,
	DoubleSide,
	EdgesGeometry,
	Euler,
	Face3,
	Font,
	FontLoader,
	FrontSide,
	Geometry,
	GridHelper,
	Group,
	HemisphereLightHelper,
	Light,
	Line,
	LineBasicMaterial,
	LineSegments,
	Material,
	MathUtils,
	Matrix3,
	Matrix4,
	Mesh,
	MeshBasicMaterial,
	MeshLambertMaterial,
	MeshPhongMaterial,
	MeshStandardMaterial,
	Object3D,
	ObjectLoader,
	PCFSoftShadowMap,
	PerspectiveCamera,
	Plane,
	PlaneGeometry,
	Quaternion,
	RawShaderMaterial,
	Raycaster,
	ShaderMaterial,
	Shape,
	ShapeGeometry,
	Sphere,
	SphereGeometry,
	TextGeometry,
	Texture,
	TextureLoader,
	Vector2,
	Vector3,
	WireframeGeometry,
	ImageLoader,
	ClampToEdgeWrapping,
	LinearFilter,
	OrthographicCamera,
	PlaneBufferGeometry,
	RGBAFormat,
	Scene,
	UnsignedByteType,
	WebGLRenderTarget,
	WebGLRenderTargetCube,
	BufferGeometry,
	FileLoader,
	Float32BufferAttribute,
	Loader,
	NoColors,
	Points,
	PointsMaterial,
	VertexColors,
	AnimationClip,
	Bone,
	BufferAttribute,
	DirectionalLight,
	InterleavedBuffer,
	InterleavedBufferAttribute,
	Interpolant,
	InterpolateDiscrete,
	InterpolateLinear,
	LineLoop,
	LinearMipmapLinearFilter,
	LinearMipmapNearestFilter,
	MirroredRepeatWrapping,
	NearestFilter,
	NearestMipmapLinearFilter,
	NearestMipmapNearestFilter,
	NumberKeyframeTrack,
	PointLight,
	PropertyBinding,
	QuaternionKeyframeTrack,
	RGBFormat,
	RepeatWrapping,
	ShaderLib,
	Skeleton,
	SkinnedMesh,
	SpotLight,
	TriangleFanDrawMode,
	TriangleStripDrawMode,
	UniformsUtils,
	VectorKeyframeTrack,
	sRGBEncoding,
	LoaderUtils,
	VideoTexture,
	PointLightHelper,
	SpotLightHelper,
	HemisphereLight,
	WebGLRenderer,
	BoxBufferGeometry,
	CylinderBufferGeometry,
	OctahedronBufferGeometry,
	SphereBufferGeometry,
	TorusBufferGeometry,
	WebGLCubeRenderTarget,
} from '../../node_modules/three/build/three.module.js';

// import {
//	RectAreaLightHelper,
//	LightProbeHelper,
//} from '../../../../src/js/three.module.js';

import { RectAreaLightHelper } from '../../node_modules/three/examples/jsm/helpers/RectAreaLightHelper.js';
import { LightProbeHelper } from '../../node_modules/three/examples/jsm/helpers/LightProbeHelper.js';

import { CubemapToEquirectangular } from  '../utils/cubemap-to-equirectangular.js';
//import CubemapToEquirectangular from  '../../js/objects/CubemapToEquirectangular.js';
window.CubemapToEquirectangular = CubemapToEquirectangular;

window.THREE = {
	REVISION,
	AmbientLight,
	AxesHelper,
	BackSide,
	Box3,
	BoxGeometry,
	BoxHelper,
	Color,
	CubeCamera,
	CubeGeometry,
	CylinderGeometry,
	DirectionalLightHelper,
	DoubleSide,
	EdgesGeometry,
	Euler,
	Face3,
	Font,
	FontLoader,
	FrontSide,
	Geometry,
	GridHelper,
	Group,
	HemisphereLightHelper,
	Light,
	LightProbeHelper,
	RectAreaLightHelper,
	Line,
	LineBasicMaterial,
	LineSegments,
	Material,
	Math: MathUtils,
	MathUtils,
	Matrix3,
	Matrix4,
	Mesh,
	MeshBasicMaterial,
	MeshLambertMaterial,
	MeshPhongMaterial,
	MeshStandardMaterial,
	Object3D,
	ObjectLoader,
	PCFSoftShadowMap,
	PerspectiveCamera,
	Plane,
	PlaneGeometry,
	Quaternion,
	RawShaderMaterial,
	Raycaster,
	ShaderMaterial,
	Shape,
	ShapeGeometry,
	Sphere,
	SphereGeometry,
	TextGeometry,
	Texture,
	TextureLoader,
	Vector2,
	Vector3,
	WireframeGeometry,
	ImageLoader,
	WebGLCubeRenderTarget
};

export {
	AmbientLight,
	AxesHelper,
	BackSide,
	Box3,
	BoxGeometry,
	BoxHelper,
	Color,
	CubeCamera,
	CubeGeometry,
	CylinderGeometry,
	DirectionalLightHelper,
	DoubleSide,
	EdgesGeometry,
	Euler,
	Face3,
	Font,
	FontLoader,
	FrontSide,
	Geometry,
	GridHelper,
	Group,
	HemisphereLightHelper,
	Light,
	LightProbeHelper,
	RectAreaLightHelper,
	Line,
	LineBasicMaterial,
	LineSegments,
	Material,
	MathUtils as Math,
	MathUtils,
	Matrix3,
	Matrix4,
	Mesh,
	MeshBasicMaterial,
	MeshLambertMaterial,
	MeshPhongMaterial,
	MeshStandardMaterial,
	Object3D,
	ObjectLoader,
	PCFSoftShadowMap,
	PerspectiveCamera,
	Plane,
	PlaneGeometry,
	Quaternion,
	RawShaderMaterial,
	ShaderMaterial,
	Shape,
	ShapeGeometry,
	Sphere,
	SphereGeometry,
	TextGeometry,
	Texture,
	TextureLoader,
	Vector2,
	Vector3,
	WireframeGeometry,
	ImageLoader,
	ClampToEdgeWrapping,
	LinearFilter,
	OrthographicCamera,
	PlaneBufferGeometry,
	RGBAFormat,
	Scene,
	UnsignedByteType,
	WebGLRenderTarget,
	WebGLRenderTargetCube,
	BufferGeometry,
	FileLoader,
	Float32BufferAttribute,
	Loader,
	NoColors,
	Points,
	PointsMaterial,
	VertexColors,
	AnimationClip,
	Bone,
	BufferAttribute,
	DirectionalLight,
	InterleavedBuffer,
	InterleavedBufferAttribute,
	Interpolant,
	InterpolateDiscrete,
	InterpolateLinear,
	LineLoop,
	LinearMipmapLinearFilter,
	LinearMipmapNearestFilter,
	MirroredRepeatWrapping,
	NearestFilter,
	NearestMipmapLinearFilter,
	NearestMipmapNearestFilter,
	NumberKeyframeTrack,
	PointLight,
	PropertyBinding,
	QuaternionKeyframeTrack,
	RGBFormat,
	RepeatWrapping,
	ShaderLib,
	Skeleton,
	SkinnedMesh,
	SpotLight,
	TriangleFanDrawMode,
	TriangleStripDrawMode,
	UniformsUtils,
	VectorKeyframeTrack,
	sRGBEncoding,
	LoaderUtils,
	Raycaster,
	VideoTexture,
	PointLightHelper,
	SpotLightHelper,
	HemisphereLight,
	WebGLRenderer,
	BoxBufferGeometry,
	CylinderBufferGeometry,
	OctahedronBufferGeometry,
	SphereBufferGeometry,
	TorusBufferGeometry,
	WebGLCubeRenderTarget
};

